var DealerRecommendedCtrl = function ($scope, previousState, customerModelService, $log, SettingsConstants, $state, $rootScope, $q, maintenanceModelService) {

    Object.defineProperty($scope, 'showLineComment', {
        enumerable: false,
        configurable: false,
        set: function (value) {
            throw new Error('You can not set read only property');
        },
        get: function () {
            return window.appSettings.displayDrsLineComments || false;
        }
    });

    //init
    //
    //@description
    //Entry point into controller client logic
    function init() {
        //dealer recommended services storage
        $scope.dealerRecommendedServices = customerModelService
            .getDealerRecommendedServices()
            .filter(function (el) {  // filter out service category 49 in case of create appointment.
                const rel =
                    "http://api.dealer-fx.com/docs/rels/maintenance-service-category";
                const serviceHref = _.get(
                    _.find(el.links, { rel: rel }),
                    "href"
                );
                // In create appointment flow we can get service category id from links . 
                if (serviceHref) {  
                    var serviceCategoryId = serviceHref.split("/").pop();
                    return serviceCategoryId !== "49";
                }  
                return true;
            });
        //maintenance services intervals
        $scope.maintenanceIntervals = maintenanceModelService.getMaintenanceIntervals();
        // to share variable between subscopes
        $scope.shared = {};
    }

    //getSelectedMileage
    //
    //@param {Array} array of maintenance intervals
    //
    //@description
    //Get mileage of the selected maintenance interval
    $scope.getSelectedMileage = function (maintenanceIntervals) {
        var interval = maintenanceIntervals.filter(function (el) {
            return el.selected;
        });
        return interval.length ? interval[0] : undefined;
    };

    //filterDialerRecommendedServices
    //
    //@description
    //Filters dealer recommended services by the given
    //filter query string
    $scope.filterDialerRecommendedServices = function () {
        //use the method of the parent scope to filter the services
        $scope.dealerRecommendedServices = $scope.filterServices(customerModelService.getDealerRecommendedServices(), $scope.serviceFilterQuery, 'name');
    };

    var drsListener = $scope.$on('bookAppoimentServicesCtrl:reloadDRS', function () {
        $scope.dealerRecommendedServices = customerModelService.getDealerRecommendedServices();
    });

    $scope.$on('$destroy', function () {
        drsListener();
    });

    //start the current controller
    init();
};
DealerRecommendedCtrl.$inject = ['$scope', 'previousState', 'customerModelService', '$log', 'SettingsConstants', '$state', '$rootScope', '$q', 'maintenanceModelService'];

module.exports = DealerRecommendedCtrl;
